// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1pkl8","topBottomGutter":"Layout_topBottomGutter__1dxgr"};